import React, { useEffect, useState } from 'react';
import FilterPanel from '../../components/ui/FilterPanel';
import Table from '../../components/ui/Table';
import { generateMerchantTransactionData } from '../../utils/dataGenerators';
const aggregatorOptions = ['Karachi', 'Lahore', 'Islamabad', 'Peshawar', 'Faisalabad'];
const statusOptions = ['All', 'Pending', 'Completed', 'Failed', 'Settled', 'Un-Settled'];
const MerchantTransaction: React.FC = () => {
  // Filter state
  const [selectedAggregators, setSelectedAggregators] = useState<string[]>([]);
  const [fromDate, setFromDate] = useState<string>(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split('T')[0];
  });
  const [toDate, setToDate] = useState<string>(() => new Date().toISOString().split('T')[0]);
  const [status, setStatus] = useState<string>('All');
  // Data state
  const [data, setData] = useState<any[]>([]);
  // Table columns
  const columns = [{
    key: 'id',
    header: 'Transaction ID',
    sortable: true
  }, {
    key: 'merchantId',
    header: 'Merchant ID',
    sortable: true
  }, {
    key: 'merchantName',
    header: 'Merchant Name',
    sortable: true
  }, {
    key: 'aggregator',
    header: 'Aggregator',
    sortable: true
  }, {
    key: 'transactionDate',
    header: 'Transaction Date',
    sortable: true
  }, {
    key: 'transactionTime',
    header: 'Transaction Time',
    sortable: true
  }, {
    key: 'amount',
    header: 'Amount (PKR)',
    sortable: true
  }, {
    key: 'status',
    header: 'Status',
    sortable: true
  }, {
    key: 'cardType',
    header: 'Card Type',
    sortable: true
  }, {
    key: 'cardNumber',
    header: 'Card Number',
    sortable: true
  }];
  // Handle filter changes
  const handleAggregatorChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const options = e.target.options;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value);
      }
    }
    setSelectedAggregators(selectedValues);
  };
  const handleApplyFilters = () => {
    const aggregators = selectedAggregators.length > 0 ? selectedAggregators : aggregatorOptions;
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
    const filteredData = generateMerchantTransactionData(aggregators, fromDateObj, toDateObj, status);
    setData(filteredData);
  };
  const handleResetFilters = () => {
    setSelectedAggregators([]);
    const date = new Date();
    setFromDate(new Date(date.setMonth(date.getMonth() - 1)).toISOString().split('T')[0]);
    setToDate(new Date().toISOString().split('T')[0]);
    setStatus('All');
  };
  // Handle export
  const handleExport = (type: 'xlsx' | 'csv' | 'pdf') => {
    // In a real app, this would trigger an actual export
    alert(`Exporting data as ${type.toUpperCase()}`);
  };
  // Initialize data on component mount
  useEffect(() => {
    handleApplyFilters();
  }, []);
  return <div data-id="element-671">
      <div className="flex items-center justify-between mb-6" data-id="element-672">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-673">
          Merchant Transaction Report
        </h1>
      </div>
      <FilterPanel title="Filter Options" onApplyFilters={handleApplyFilters} onResetFilters={handleResetFilters} data-id="element-674">
        <div data-id="element-675">
          <label htmlFor="aggregator" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-676">
            Aggregator
          </label>
          <select id="aggregator" multiple value={selectedAggregators} onChange={handleAggregatorChange} className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" size={5} data-id="element-677">
            {aggregatorOptions.map(option => <option key={option} value={option} data-id="element-678">
                {option}
              </option>)}
          </select>
          <p className="mt-1 text-xs text-gray-500" data-id="element-679">
            Hold Ctrl/Cmd to select multiple
          </p>
        </div>
        <div data-id="element-680">
          <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-681">
            From Date
          </label>
          <input type="date" id="fromDate" value={fromDate} onChange={e => setFromDate(e.target.value)} className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-682" />
        </div>
        <div data-id="element-683">
          <label htmlFor="toDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-684">
            To Date
          </label>
          <input type="date" id="toDate" value={toDate} onChange={e => setToDate(e.target.value)} className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-685" />
        </div>
        <div data-id="element-686">
          <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-687">
            Transaction Status
          </label>
          <select id="status" value={status} onChange={e => setStatus(e.target.value)} className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-688">
            {statusOptions.map(option => <option key={option} value={option} data-id="element-689">
                {option}
              </option>)}
          </select>
        </div>
      </FilterPanel>
      <Table columns={columns} data={data} onExport={handleExport} data-id="element-690" />
    </div>;
};
export default MerchantTransaction;